import { localStorageSync } from 'ngrx-store-localstorage';
import { ActionReducer } from '@ngrx/store';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      'items',
      'columns',
      'expandedId',
      'expandedList',
      'page',
      'tempPage',
      'events',
      'campaigns',
      'filterTags',
      'tempFilterTags',
      'tempEditedFilters',
      'editedFilters',
      'editedFiltersItems',
      'openedFilter',
      'openedTagGroupTooltips',
      'callLengthForm',
      'editingFilterSnapshot'
    ],
    storage: sessionStorage,
    rehydrate: true,
    removeOnUndefined: true
  })(reducer);
}
